import React, {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation} from 'swiper';
import {Button, TextField} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
// import Vimeo from '@u-wave/react-vimeo';

import VideoMediaCard from 'components/VideoMediaCard';

import './MediaLibraryCarousel.scss';
import MediaLibraryModal from './MediaLibraryModal';

SwiperCore.use([Navigation]);

function MediaLibraryCarousel({mediatheque}) {
  const {t} = useTranslation();
  const [media, setMedia] = useState();
  const [searchString, setSearchString] = useState('');

  const refPrev = useRef(null);
  const refNext = useRef(null);

  const swiperProps = {
    spaceBetween: 50,
    slidesPerView: 4,
    navigation: {
      prevEl: refPrev.current,
      nextEl: refNext.current,
    },
    pagination: {clickable: true},
    scrollbar: {draggable: true},
    // onSwiper: swiper => console.log(swiper),
    // onSlideChange: () => console.log('slide change'),
    breakpoints: {
      // when window width is >= 320px
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      460: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      660: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      850: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  };

  const filteredMediatheque = mediatheque.filter(video => {
    return (
      video.title?.toLowerCase().includes(searchString.toLowerCase()) ||
      video.description?.toLowerCase().includes(searchString.toLowerCase())
    );
  });

  return (
    <div className="MediaLibraryCarousel-container">
      <MediaLibraryModal
        media={media}
        onClose={() => {
          setMedia(null);
        }}
      />
      <div className="MLC-header-container">
        <div className="MLC-header-left-container">
          <div className="MLC-header-title">{t('mediatheque')}</div>
          <div className="MLC-header-searchbar">
            <TextField
              className="MLC-header-input"
              label="Rechercher un média"
              value={searchString}
              onChange={e => {
                setSearchString(e.target.value);
              }}
            />
            <i className="gg-search" />
          </div>
        </div>
        <div className="MLC-header-arrows">
          <Button ref={refPrev}>
            <ArrowBackIcon />
          </Button>
          <Button ref={refNext}>
            <ArrowForwardIcon />
          </Button>
        </div>
      </div>
      <Swiper {...swiperProps}>
        {filteredMediatheque.map((video, i) => (
          <SwiperSlide key={i}>
            <VideoMediaCard
              banner={video.sticker}
              endDate={video.to_at ? new Date(video.to_at) : false}
              title={video.title}
              thumbnail={video.thumbnail}
              duration={video.duration}
              description={video.description}
              media={video.media}
              onClick={() => setMedia(video)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default MediaLibraryCarousel;
